import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-967b9e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-6" }

import UsersTable from "@/components/organisms/UsersTable.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'UsersView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UsersTable)
  ]))
}
}

})